// assets/orchard-timeline.js
window.orchardTimeline = [
  {
    title: "2020",
    media: "https://cdn.shopify.com/s/files/1/0711/9532/8751/files/images.jpg?v=1752425421",
    text: "We started posting about what inspires us on social media, people enjoyed it and we built a following. That page was called Orchard Magazine."
  },
  {
    title: "June 2024",
    media: "https://cdn.shopify.com/s/files/1/0711/9532/8751/files/sticker2_b5f1bce8-b03c-49f1-9e95-5a3f5926644c.png?v=1745365589",
    text: "We felt like our lives were moving away from each other and wanted to do something that would keep our friends close and our community together. We created a subbrand, Orchard. We asked people what community meant to them and built around that."
  },
  {
    title: "July 2024",
    media: "https://cdn.shopify.com/s/files/1/0711/9532/8751/files/DSC01998.jpg?v=1752423911",
    text: "We released our merch with the help of local artists. And we threw a launch party, inviting old and new friends."
  },
  {
    title: "Aug 2024",
    media: "https://cdn.shopify.com/s/files/1/0711/9532/8751/files/001334370003.jpg?v=1744408822",
    text: "The first party had gone so well, we decided to throw another; it was bigger, it was better, we made even more friends."
  },
  {
    title: "Oct 2024",
    media: "https://cdn.shopify.com/s/files/1/0711/9532/8751/files/DSC_0310_3c62427a-5c8d-4ebc-a438-052365dd6b8f.jpg?v=1752423922",
    text: "We wanted to do something to honour art, we worked with talented artists and designers to curate a sustainable Halloween-themed fashion show, we rented out an art gallery and threw a sold-out show with no experience."
  },
  {
    title: "Feb 2025",
    media: "https://cdn.shopify.com/s/files/1/0711/9532/8751/files/IMG_4767_0752c29b-43aa-46fb-8176-8d20409219e0.jpg?v=1752423919",
    text: "By now, we wanted to do something different, and the perfect opportunity came along so we hosted an indoor beach volleyball tournament, we had an after party and we also had our first ever event sponsor!"
  },
  {
    title: "June 2025",
    media: "https://cdn.shopify.com/s/files/1/0711/9532/8751/files/IMG_5054.jpg?v=1752423915",
    text: "We decided to place more of an emphasis on selling art (because we were losing money on every event) so we contacted a bunch of artists and threw a party at an arcade bar to celebrate this new chapter. This was our biggest event yet, and we sold out."
  },
  {
    title: "Aug 2025",
    media: "https://cdn.shopify.com/s/files/1/0711/9532/8751/files/Untitled_design.png?v=1739600674",
    text: "I am writing this in August 2025—no idea what the future holds, but as long as you are having fun and we are too, we will continue to do this."
  }
];




 